import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Util} from "../../app/util";
import {CONFIG} from "../../app/config";
import {FormControl} from "@angular/forms";
import {Keyboard, TextInput} from "ionic-angular";

@Component({
    selector: 'searched',
    templateUrl: 'searched.html'
})

export class Searched {

    public config: any;

    /** COLOR **/
    @Input('keyboard-hide')  private keyboardHide: boolean;
    @Output('keyboard-find') private _click: EventEmitter<any> = new EventEmitter();

    @ViewChild('searchbar') searchbar: TextInput;

    searchTerm: string = '';
    searchControl: FormControl = new FormControl();
    searching: boolean;

    constructor(public util: Util, public keyboard: Keyboard) {

        this.config = CONFIG;

        window.addEventListener('keyboardDidHide', () => {
            // Describe your logic which will be run each time keyboard is closed.
            if (this.keyboardHide) this.searchStart(true);
        });

    }

    ngOnInit() {


    }

    searchStart(isEnter = false) {

        //CNPJ/CNPF - Format
        if (this.util.validaCNPF(this.searchTerm)) this.searchTerm = this.util.formatDOC(this.searchTerm);
        if (this.util.validaCNPJ(this.searchTerm)) this.searchTerm = this.util.formatDOC(this.searchTerm);

        this.searching = true;
        this._click.emit(this.searchTerm);
        this.searchClose();

    }

    searchClose() {

        this.keyboard.close();

    }

    setFocus() {

        setTimeout(() => {
            if (this.searchbar) this.searchbar.setFocus();
        }, 500);

    }

}



// WEBPACK FOOTER //
// ./src/components/searched/searched.ts